import script from "./CostsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CostsModal.vue?vue&type=script&setup=true&lang=js"

import "./CostsModal.vue?vue&type=style&index=0&id=4964a67e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4964a67e"]])

export default __exports__